import * as S from '@effect/schema/Schema';
import { Effect, Function, Record, Request, RequestResolver } from 'effect';
import * as Url from '../../url';
import { Realisation } from '../schema';
import { ServerError } from '../service';
export const RealisationResponse = S.Struct({
    cursor: S.optional(S.String),
    realisations: S.Array(Realisation),
});
const tag = '@fixtuur/backpack/GetAllRealisations';
export const GetAllRealisations = Request.tagged(tag);
export const makeGetAllRealisationsResolver = (http) => RequestResolver.fromEffect((request) => {
    const query = Function.pipe(Record.empty(), Record.set('limit', request.limit.toString()), query => (request.cursor ? Record.set(query, 'cursor', request.cursor) : query), query => request.productId ? Record.set(query, 'productId', request.productId) : query, query => request.particleId ? Record.set(query, 'particleId', request.particleId) : query);
    return http
        .get(Url.join(request.baseUrl, `/api/v1/${request.tenant}/realisations`, query), {
        authorization: `Bearer ${request.bearerToken}`,
    })
        .pipe(Effect.flatMap(res => S.decodeUnknown(RealisationResponse)(res.body)), Effect.catchAll(originalError => new ServerError({ originalError })));
});
